import React from 'react';
import { useIntl } from 'react-intl';

import Grid from '@/components/Grid/Grid';
import PageNext from '@/components/Page/PageNext';
import RegisterCandidateForm from '@/components/Register/RegisterCandidateForm';
import { NextPage } from '@/pages/_app';

const RegisterCandidatePage: NextPage = ({ query }) => {
  const intl = useIntl();
  const inviteId = typeof query.invite === 'string' && query.invite ? query.invite : undefined;
  const returnUrl = typeof query.return_url === 'string' && query.return_url ? query.return_url : undefined;

  return (
    <PageNext title={intl.formatMessage({ id: 'app.register.developer.pagetitle' })}>
      <div className="geecko-registerform-container">
        <Grid container fullHeight alignContent="center" alignItems="center" justify="center">
          <Grid item xs={12}>
            <div style={{ maxWidth: 916, margin: '0 auto' }}>
              <RegisterCandidateForm returnUrl={returnUrl} inviteId={inviteId} />
            </div>
          </Grid>
        </Grid>
      </div>
    </PageNext>
  );
};

RegisterCandidatePage.accessGroups = 'public';

export default RegisterCandidatePage;
